import { fr, de } from "intl-tel-input/locale";

const LOCALES = {
  fr,
  de,
};

const DEFAULT_LOCALE_ISO = "fr";

export const getLocaleData = (localeIso) => {
  return LOCALES[localeIso] || LOCALES[DEFAULT_LOCALE_ISO];
};

export const getLocaleIso = (localeIso) => {
  if (LOCALES[localeIso]) {
    return localeIso;
  } else {
    return DEFAULT_LOCALE_ISO;
  }
};
